module.exports = __webpack_public_path__ + "static/media/arbre-bleu-fonce.03e36d76.png";